// extracted by mini-css-extract-plugin
export default {"app":"App_app__4SIkX","popperHost":"App_popperHost__AspFP","spinner":"App_spinner__Ee1jM"};